// extracted by mini-css-extract-plugin
export var logos = "incentives-module--logos--3gtkI";
export var logoContainer = "incentives-module--logoContainer--P5LoD";